module.exports = __webpack_public_path__ + "img/121.5155aa2a.png";